export enum ReportStatusEnum {
  ALL = 'ALL',
  WAITING = 'WAITING',
  REPORTED = 'REPORTED',
  SUCCESS = 'SUCCESS',
  BANED = 'BANED',
}
